import { render } from "./RevenueFromBranch.vue?vue&type=template&id=1b9b9a69&scoped=true"
import script from "./RevenueFromBranch.vue?vue&type=script&lang=js"
export * from "./RevenueFromBranch.vue?vue&type=script&lang=js"

import "./RevenueFromBranch.vue?vue&type=style&index=0&id=1b9b9a69&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b9b9a69"]])

export default __exports__